<template>
  <div
    v-if="result"
    class="fortune-wheel normalize"
    :style="`background-image: url(${getPicture.src})`"
  >
    <div class="fortune-wheel__block">
      <h2 v-if="result.wheel" class="fortune-wheel__title">{{ result.wheel.name }}</h2>
      <p class="fortune-wheel__text" v-html="result.wheel.detailText"></p>
      <form class="fortune-wheel__form" @submit.prevent="handlerSubmitForm">
        <!--              :placeholder="result.messages.email"-->
        <DefEmail
          name="email"
          required
          :placeholder="result.messages.email"
          @change="email = $event.target.value"
        />
        <DefPhone
          name="phone"
          :placeholder="result.messages.phone"
          @change="phone = $event.target.value"
        />
        <DefButtonPrimary
          ref="button"
          type="submit"
          :load="
            !result.wheel.active ||
            !result.wheel.isAvailable ||
            (responseData?.wheel && !responseData?.wheel?.isAvailable)
          "
        >
          {{ result.messages.btnSend }}
        </DefButtonPrimary>
      </form>
    </div>

    <DealWheel ref="wheel" :prizes="result.items" @transitionEnd="transitionEnd" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { screenWidth } from '@use/useDeviceInfo';
import useModal from '@use/useModal/useModal';
import ModalWheel from '@components/FortuneWheel/ModalWheel.vue';
import DealWheel from '@components/FortuneWheel/DealWheel.vue';
import Recaptcha3 from '@/utils/Recaptcha3';

export default {
  name: 'FortuneWheel',
  components: { DealWheel, DefButtonPrimary, DefEmail, DefPhone },
  props: ['result'],
  data() {
    return {
      email: '',
      phone: '',
      responseData: {},
      screenWidth,
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      LANGUAGE_ID: ({ personal }) => personal.data.LANGUAGE_ID,
    }),
    getActiveNumber() {
      if (this.responseData.items) {
        return this.responseData?.items?.findIndex((el) => el.winStatus);
      }
    },
    getActiveProduct() {
      if (this.responseData.items) {
        return this.responseData?.items?.find((el) => el.winStatus);
      }
    },
    getPicture() {
      try {
        const { pictures } = this.result.wheel;
        if (pictures) {
          return this.screenWidth < 768 ? pictures.mobile : pictures.desktop;
        }
        return this.result?.wheel?.picture;
      } catch (err) {
        console.error(err);
      }
    },
  },
  methods: {
    showText(text) {
      this.modal.show(ModalWheel, { result: text }, { width: '440px' });
    },
    async handlerSubmitForm() {
      try {
        const token = await Recaptcha3.getSubmitToken();
        const { status, data } = await axios.get(location.href, {
          params: {
            email: this.email,
            phone: this.phone,
            spin: 'Y',
            api: 'Y',
            LANGUAGE_ID: this.LANGUAGE_ID,
            'g-recaptcha-response': token,
          },
        });

        this.responseData = data;

        if (status !== 200) throw `bad response status: ${status}`;

        if (data.error) {
          this.showText(data.error);
        } else {
          this.$refs.wheel.numberOfPrize = this.getActiveNumber + 1;
          this.$refs.wheel.handlerTriggerClick(this.$refs.button.$el);
        }
      } catch (err) {
        console.error(err);
      }
    },
    transitionEnd() {
      this.$refs.button.$el.disabled = false;

      this.showText(this.getActiveProduct.winMessage);
    },
  },
};
</script>

<style lang="scss" scoped>
.fortune-wheel {
  @extend %container;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 30px;
  box-sizing: border-box;
  padding-top: 30px;
  padding-bottom: 30px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  @include point-md {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  @include point-lg {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 50px;
  }
  &__form {
    display: flex;
    flex-direction: column;
  }
  &__block {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__title {
    font-weight: 700;
    font-size: rem(30);
    margin-bottom: 24px;
    color: #628eab;
  }
  &__text {
    margin-bottom: 40px;
    color: #628eab;
  }

  //.def-button{
  //    &:disabled {
  //        /* меняем внешний вид курсора */
  //        cursor: progress;
  //        /* делаем кнопку полупрозрачной */
  //        opacity: 0.25;
  //    }
  //}
  :deep {
    .def-email {
      margin-bottom: 20px;
      &__input {
        padding: 0 25px 0 15px;
      }
      &__icon-error {
        right: 10px;
      }
    }
  }
}
</style>
